import { Component } from 'react'
import { Input } from '../../../../../components/input'
import { SubmitBtn } from '../../../../../components/submit'
import { emptyField, ErrorMessage, errorsLength, formatErrors, validateCEP } from '../../../../../../insfrastructure/utils/form-validators'
import { Select } from '../../../../../components/select'
import { DateOfBirthField } from '../../../../../components/date-of-birth-field'
import { formatDateOnly, normalizeDateOnlyFromApi } from '../../../../../../insfrastructure/utils/date-formatter'
import { updateCandidate } from '../../../../../../insfrastructure/services/candidates'
import { CVDownloadHelper } from '../../../../../../insfrastructure/utils/cv-download-helper'
import ValidationModal from '../../../../../components/validation-modal'
import { listCities } from '../../../../../../insfrastructure/services/cities'
import { StaticValues } from '../../../../../../insfrastructure/services/static_values'
import ResponseModal from '../../../../../components/response-modal'
import { retrievePostcodeInfo } from '../../../../../../insfrastructure/services/cep'
import moment from 'moment'
import downloadIcon from '../../../../../../assets/icons/document.png'
import './styles.sass'

export default class PersonalForm extends Component<{ candidateProfile?: any, onProfileUpdate?: (profile: any) => void, loading?: boolean }> {

  state: any = {
    form: {
      email: '',
      password: '',
      full_name: '',
      mobile: '',
      date_of_birth: null,
      gender: '',
      salary_expectation: '',
      marital_status: '',
      education_level: '',
      disability: '',
      expecific_disability: '',
      postcode: '',
      address: '',
      address_number: '',
      address_complement: '',
      address_district: '',
      city_id: '',
      city_uf: '',
      cnh_number: '',
      cnh_validity: null,
      cnh_category: ''
    },
    cnh_categories: [],
    formErrors: {},
    validationModal: {
      isOpen: false,
      message: '',
      missingFields: []
    },
    loading: false,
    cityOptions: [],
    downloadCVLoading: false
  }
  timeout: any = null

  async componentDidMount() {
    this.getStaticValues();
  }

  componentDidUpdate(prevProps: any) {
    if (prevProps.candidateProfile !== this.props.candidateProfile && this.props.candidateProfile) {
      let candidate = { ...this.props.candidateProfile };

      if (candidate.date_of_birth) {
        // Normaliza para YYYY-MM-DD (sem timezone) e converte para DD/MM/YYYY para o DateOfBirthField
        const normalized = normalizeDateOnlyFromApi(candidate.date_of_birth);
        if (normalized) {
          candidate.date_of_birth = moment(normalized, 'YYYY-MM-DD').format('DD/MM/YYYY') as any;
        }
      };

      // Mesclar com os valores padrão para evitar campos undefined
      const updatedForm = {
        ...this.state.form,
        ...candidate
      };

      // Normaliza cnh_validity para evitar shift por timezone ao exibir no DatePicker
      if (updatedForm.cnh_validity) {
        const normalized = normalizeDateOnlyFromApi(updatedForm.cnh_validity);
        if (normalized) {
          updatedForm.cnh_validity = normalized as any;
        }
      }

      this.setState({ form: updatedForm }, () => {
        this.onCEPChange(this.state.form.postcode);
      });
    }
  }

  getStaticValues = async () => {
    try {  
      setTimeout(() => {
        const staticValues = JSON.parse(localStorage.getItem('static_values')+'') as StaticValues;
        const cnh_categories = Object.keys(staticValues.cnh_category).map((key: any) => ({ value: key, label: staticValues.cnh_category[key] }));
        const marital_status = Object.keys(staticValues.marital_status).map((key: any) => ({ value: key, label: staticValues.marital_status[key] }));
        const gender = Object.keys(staticValues.gender).map((key: any) => ({ value: key, label: staticValues.gender[key] }));
        const education_level = Object.keys(staticValues.education_level).map((key: any) => ({ value: key, label: staticValues.education_level[key] }));
        const disability = Object.keys(staticValues.disability).map((key: any) => ({ value: key, label: staticValues.disability[key] }));     
        
        this.setState({ cnh_categories, marital_status, gender, education_level, disability });
      }, 1000);
    } catch (error) {}
  }

  onSubmit = async () => {
    const errors = formatErrors({
      full_name: [emptyField(this.state.form.full_name, 'string')],
      postcode: [emptyField(this.state.form.postcode, 'string')],
      city_id: [emptyField(this.state.form.city_id, 'string')],
      mobile: [emptyField(this.state.form.mobile, 'string')],
      education_level: [emptyField(this.state.form.education_level, 'string')],
      cnh_category: [emptyField(this.state.form.cnh_category, 'string')]
    });

    this.setState({ formErrors: errors });
  
    if(errorsLength(errors) > 0) return;

    try {
      this.setState({ loading: true });
  
      let data = {...this.state.form};
  
      if (data.date_of_birth) {
        const formatted = formatDateOnly(data.date_of_birth);
        data.date_of_birth = formatted || moment(data.date_of_birth).format('YYYY-MM-DD');
      }
        
      if (data.cnh_validity) {
        // Evita “voltar 1 dia” por timezone/UTC (toISOString). Converte para YYYY-MM-DD como data pura.
        const formatted = formatDateOnly(data.cnh_validity);
        if (formatted) data.cnh_validity = formatted as any;
      };

      !data.escola_do_mecanico_id && delete data.escola_do_mecanico_id;
      if (!data.address_complement || (typeof data.address_complement === 'string' && data.address_complement.trim() === '')) {
        data.address_complement = null;
      };
                 
      const candidate = await updateCandidate(localStorage.getItem('candidate_id')+'', data);

      // Atualizar o perfil no componente pai
      if (this.props.onProfileUpdate) {
        this.props.onProfileUpdate(candidate);
      }

      let responseData = {
        type: 'success',
        title: 'Dados atualizados com sucesso!',
        text: () => <></>
      };
        
      setTimeout(() => {
        // Normaliza date_of_birth após salvar para evitar mostrar "um dia antes" até dar F5
        const updatedCandidate: any = { ...candidate };
        if (updatedCandidate.date_of_birth) {
          const normalized = normalizeDateOnlyFromApi(updatedCandidate.date_of_birth);
          if (normalized) {
            updatedCandidate.date_of_birth = moment(normalized, 'YYYY-MM-DD').format('DD/MM/YYYY') as any;
          }
        }

        this.setState({ loading: false, form: updatedCandidate, responseData });
      });
    } catch (error: any) {
      let errors: string[] = [];

      // Verificação segura: só acessa error.response.data se existir
      if (error.response && error.response.data) {
        if (error.response.data['email']) {
          errors.push('Email já cadastrado');
        };
        
        if (error.response.data['username']) {
          errors.push('Nome de usuário já cadastrado');
        };
      }

      // Se não há erros específicos da API, mostrar mensagem genérica
      if (errors.length === 0) {
        errors.push('Erro ao processar atualização. Tente novamente.');
      }

      let responseData = {
        type: 'error',
        title: 'Erro ao atualizar dados',
        text: () => <>
          { errors.map(error => <p>{error}</p>) }
        </>
      };

      this.setState({ loading: false, responseData });
    }
  }

  downloadCV = async () => {
    try {
      this.setState({ downloadCVLoading: true });
      
      // Usar o ID do candidato do localStorage
      const candidateId = localStorage.getItem('candidate_id');
      
      if (!candidateId) {
        throw new Error('ID do candidato não encontrado. Faça login novamente.');
      }
      
      // Usar o helper com validação (sem download automático)
      const result = await CVDownloadHelper.downloadCVWithValidation(candidateId);
      
      if (!result.success) {
        // Se for erro de validação, mostrar modal com campos faltantes
        if (result.isValidationError && result.missingFields && result.missingFields.length > 0) {
          this.setState({
            validationModal: {
              isOpen: true,
              message: result.error || 'Perfil incompleto',
              missingFields: result.missingFields
            }
          });
          return; // Não fazer throw, apenas mostrar modal
        } else {
          throw new Error(result.error || 'Erro ao baixar currículo');
        }
      }
      
      // Se chegou aqui, a validação passou, fazer o download
      if (result.blob) {
        const url = window.URL.createObjectURL(result.blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `meu_curriculo_${this.state.form.full_name?.replace(/\s+/g, '_') || 'candidato'}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }
      
    } catch (error: any) {
      console.error('Erro ao baixar currículo:', error);
      
      // Mostrar mensagem específica do erro se disponível
      const errorMessage = error.message || 'Erro ao baixar o currículo. Tente novamente.';
      alert(errorMessage);
    } finally {
      this.setState({ downloadCVLoading: false });
    }
  }

  closeValidationModal = () => {
    this.setState({
      validationModal: {
        isOpen: false,
        message: '',
        missingFields: []
      }
    });
  }

  goToProfileCompletion = () => {
    this.closeValidationModal();
    // Aqui você pode adicionar lógica para navegar para a seção de completar perfil
    // Por exemplo, rolar para uma seção específica ou abrir um modal de edição
    console.log('Redirecionar para completar perfil');
  }

  onCityNameChange = async (e: any) => {
    const cityOptions = (await listCities(e)).map(x => ({ value: x.id, label: x.displayName }));

    this.setState({ cityOptions });
  }

  onCEPChange = async (value: any) => {
    clearTimeout(this.timeout);
    
    this.timeout = setTimeout(async () => {
      let city_id = '';
      let city_uf = '';
      let address_district = '';
      let street = '';
      let result = null;

      if(validateCEP(value) === '') {
        try {
          result = await retrievePostcodeInfo(value);
        } catch (error) {
          this.setState({
            responseData: {
              type: 'error',
              title: 'CEP Inválido',
              text: ''
            }
          });

          return;
        };

        this.onCityNameChange(result?.cidade);
        city_id = result?.city_id + '';
        city_uf = result?.uf + '';
        address_district = result?.bairro + '';
        street = result?.logradouro + '';
      };
  
      this.setState({
        form: {
          ...this.state.form,
          city_id,
          city_uf,
          address_district,
          address: street
        }
      });
    }, 1000);
  }

  render() {
    return (
      <div className='personal-form'>
        <h1>Dados Pessoais</h1>
        <div className='columns'>
          <div className='column'>
            <Input
            name='full_name'
            label='Nome Completo'
            value={this.state.form['full_name']}
            onChange={e => this.setState({ form: { ...this.state.form, full_name: e } })}/>
            <ErrorMessage errors={this.state.formErrors['full_name']} />
            <Input
            name='mobile'
            label='Celular'
            mask='(99) 99999-9999'
            value={this.state.form['mobile']}
            onChange={e => this.setState({ form: { ...this.state.form, mobile: e } })}/>
            <ErrorMessage errors={this.state.formErrors['mobile']} />
            <DateOfBirthField
            name='date_of_birth'
            label='Data Nascimento'
            value={this.state.form['date_of_birth']}
            onChange={e => this.setState({ form: { ...this.state.form, date_of_birth: e } })}
            errors={this.state.formErrors['date_of_birth']} />
            <Select
            name='gender'
            label='Gênero'
            value={this.state.form['gender']}
            options={this.state.gender}
            onChange={e => this.setState({ form: { ...this.state.form, gender: e } })}/>
            <ErrorMessage errors={this.state.formErrors['gender']} />
          </div>
          <div className='column'>
            <Input
            name='salary_expectation'
            label='Pretensão Salarial'
            value={this.state.form['salary_expectation']}
            onChange={e => this.setState({ form: { ...this.state.form, salary_expectation: e } })}/>
            <ErrorMessage errors={this.state.formErrors['salary_expectation']} />
            <Select
            name='marital_status'
            label='Estado Civil'
            value={this.state.form['marital_status']}
            options={this.state.marital_status}
            onChange={e => this.setState({ form: { ...this.state.form, marital_status: e } })}/>
            <ErrorMessage errors={this.state.formErrors['marital_status']} />
            <Select
              name='education_level'
              label='Escolaridade'
              placeholder='Escolaridade'
              value={this.state.form['education_level']}
              options={this.state.education_level}
              onChange={e => this.setState({ form: { ...this.state.form, education_level: e } })}/>
              <ErrorMessage errors={this.state.formErrors['education_level']} />
            <Select
            name='disability'
            label='Deficiência'
            value={this.state.form['disability']}
            options={this.state.disability}
            onChange={e => this.setState({ form: { ...this.state.form, disability: e } })}/>
            {this.state.form.disability === 'Outro' &&
            <>
              <Input
              name='expecific_disability'
              label='Especificar Deficiência'
              onChange={e => this.setState({ form: { ...this.state.form, expecific_disability: e } })}/>
              <ErrorMessage errors={this.state.formErrors['expecific_disability']} />
            </>}
          </div>
        </div>
        <div className='columns'>
          <div className='column'>
            <Input
            name='postcode'
            label='CEP'
            mask='99999-999'
            value={this.state.form.postcode}
            onChange={e => { this.setState({ form: { ...this.state.form, postcode: e } }); this.onCEPChange(e); }}/>
            <ErrorMessage errors={this.state.formErrors['postcode']} />
            <Input
            name='address'
            label='Endereço'
            value={this.state.form.address}
            readonly={true}
            onChange={e => this.setState({ form: { ...this.state.form, address: e } })}/>
            <ErrorMessage errors={this.state.formErrors['address']} />
            <Input
            name='address_number'
            label='Número'
            value={this.state.form.address_number}
            onChange={e => this.setState({ form: { ...this.state.form, address_number: e } })}/>
            <ErrorMessage errors={this.state.formErrors['address_number']} />
            <Input
            name='address_complement'
            label='Complemento'
            value={this.state.form.address_complement}
            onChange={e => this.setState({ form: { ...this.state.form, address_complement: e } })}/>
            <ErrorMessage errors={this.state.formErrors['address_complement']} />
          </div>
          <div className='column'>
          <Input
            name='address_district'
            label='Bairro'
            value={this.state.form.address_district}
            readonly={true}
            onChange={e => this.setState({ form: { ...this.state.form, address_district: e } })}/>
            <ErrorMessage errors={this.state.formErrors['address_district']} />
            <Select
            name='city_id'
            label='Cidade'
            options={this.state.cityOptions}
            value={this.state.form.city_id}
            readonly={true}
            onSearchChange={e => this.onCityNameChange(e)}
            onChange={e => this.setState({ form: { ...this.state.form, city_id: e } })}/>
            <ErrorMessage errors={this.state.formErrors['city_id']} />
            <Input
            name='city_uf'
            label='Estado'
            value={this.state.form.city_uf}
            readonly={true}
            onChange={e => this.setState({ form: { ...this.state.form, city_uf: e } })}/>
            <ErrorMessage errors={this.state.formErrors['city_uf']} />
          </div>
        </div>
        <div className='columns'>
          <div className='column'>
            <Input
            name='cnh_number'
            label='Número da CNH'
            value={this.state.form.cnh_number}
            onChange={e => this.setState({ form: { ...this.state.form, cnh_number: e } })}/>
            <ErrorMessage errors={this.state.formErrors['cnh_number']} />
            <Input
            name='cnh_validity'
            label='Validade da CNH'
            type='date'
            value={this.state.form.cnh_validity}
            onChange={e => this.setState({ form: { ...this.state.form, cnh_validity: e } })}/>
            <ErrorMessage errors={this.state.formErrors['cnh_validity']} />
          </div>
          <div className='column'>
            <Select
            name='cnh_category'
            label='Categoria da CNH'
            value={this.state.form.cnh_category}
            options={this.state.cnh_categories}
            onChange={e => this.setState({ form: { ...this.state.form, cnh_category: e } })}/>
            <ErrorMessage errors={this.state.formErrors['cnh_category']} />
          </div>
        </div>
        <div className='action-buttons'>
          <button 
            className='download-cv-btn' 
            onClick={this.downloadCV}
            disabled={this.state.downloadCVLoading}
          >
            <img src={downloadIcon} alt='download-icon' />
            <span>{this.state.downloadCVLoading ? 'Baixando...' : 'Baixar currículo'}</span>
          </button>
          <SubmitBtn className='secondary' text='Salvar Alterações' loadingText='Salvando...' loading={this.state.loading} onSubmit={this.onSubmit} />
        </div>
        <ResponseModal
        render={this.state.responseData}
        type={this.state.responseData?.type}
        title={this.state.responseData?.title}
        text={this.state.responseData?.text}
        onClose={() => this.setState({ responseData: null })} />
        
        <ValidationModal
          render={this.state.validationModal.isOpen}
          message={this.state.validationModal.message}
          missingFields={this.state.validationModal.missingFields}
          onClose={this.closeValidationModal}
          onCompleteProfile={this.goToProfileCompletion}
        />
      </div>
    )
  }
}
